import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const AnimatedLoader = ({ total, current }) => {
  const progress = (current / total) * 100;
  const [animatedProgress, setAnimatedProgress] = useState(0);

  useEffect(() => {
    setAnimatedProgress(progress);
  }, [progress]);

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '10px',
        backgroundColor: '#E3F2FD',
        borderRadius: '8px',
        overflow: 'hidden'
      }}
    >
      {/* Background progress bar */}
      <motion.div
        style={{
          height: '100%',
          background: 'linear-gradient(90deg,rgb(27, 115, 203),rgb(98, 166, 234))', // Darker blue color
          position: 'absolute',
          width: `${animatedProgress}%`
        }}
        initial={{ width: 0 }}
        animate={{ width: `${animatedProgress}%` }}
        transition={{ duration: 1, ease: 'easeInOut' }}
      />

      {/* Fluid motion effect */}
      <motion.div
        style={{
          height: '100%',
          width: '100%',
          position: 'absolute',
          background: '#d1e0ea',
          backgroundSize: '200% 100%',
          mixBlendMode: 'multiply'
        }}
      />
    </div>
  );
};

export default AnimatedLoader;
